import React, { useEffect, useContext, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../../components/Navbar';
import Header from '../../components/Header';
import SectionUpper from './SectionUpper';
import DaftarInformasi from './DaftarInformasi';
import UserAuthContext from '../../components/Context/userContext';
import config from '../../config';
import ModalMahasiswa from './ModalMahasiswa';

const Home = () => {
  const userConsumer = useContext(UserAuthContext);

  const query = new URLSearchParams(useLocation().search);
  const state = query.get('token');
  const history = useHistory();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (state) {
      axios.post(`${config.API_BASE_URL}api/account/token/refresh/`, { refresh: state }, {
        headers: {
          'content-type': 'application/json',
          accept: 'application/json',
        },
      }).then(
        (result) => {
          localStorage.setItem('accessToken', result.data.access);
          localStorage.setItem('refreshToken', state);
          axios.get(`${config.API_BASE_URL}api/account/`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            },
          }).then(
            ({ data }) => {
              let role = null;
              if (data.data.is_superuser) {
                role = 'superadmin';
              } else if (data.data.is_staff) {
                role = 'admin';
              } else {
                role = 'mahasiswa';
                if (!data.data.data_mahasiswa) {
                  setShow(true);
                }
              }
              localStorage.setItem('role', role);
              localStorage.setItem('nama', data.data.name);
              userConsumer.setUserAuth(role);
            },
          );
          history.replace({
            search: '',
          });
        },
      );
    }
  }, []);

  return (
    <>
      <Navbar />
      <Header />
      <SectionUpper />
      <DaftarInformasi />
      <ModalMahasiswa
        show={show}
        onHide={() => setShow(false)}
      />
    </>
  );
};

export default Home;
